import React from 'react';
function Footer(): JSX.Element {
    return (
        <div className="evg_footer">
            <div className="section">
                <div className="align_wh">
                    <div className="footer_wrap">
                        <address className="smallfont">
                            Copyright ©{' '}
                            <strong>
                                <a
                                    href="http://www.douzone.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    DOUZONE BIZON.
                                </a>
                            </strong>{' '}
                            All rights reserved.
                        </address>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
